

import React, { useContext } from 'react';
import '../css/warning.css';
import { AgentContext } from '../context/AgentContext';


function Warning({title, message, buttons, confirm, cancel}) {
    const {isB2B} = useContext(AgentContext)
    return (
        <div className="warningWrapper">
            <div className="warningBody">
                <div className="warningHeader">
                    {title}
                </div>
                <div className="warningContent">
                    {message}
                </div>
                <div className="warningButtonHolder">
                    <div className="warningButtonWrapper">
                        {buttons.map((button, index) => ( //solidQuilityDestructiveButton
                            <div className={`accentButton warningButton ${button.action !== 'confirm' ? 'solidQuilityDestructiveButton': `${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`}`} key={'warning'+index} onClick={()=>`${button.action !== 'confirm' ? cancel() : confirm()}`}>{button.name}</div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Warning;